module.exports = new __parcel__URL__("fieryinfliction.a866edf5.png").toString();